/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'

/**
 *
 * @export
 * @interface EnvelopedReviewAdminCreate
 */
export interface EnvelopedReviewAdminCreate {
  /**
   *
   * @type {any}
   * @memberof EnvelopedReviewAdminCreate
   */
  body: any | null
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedReviewAdminCreate
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedReviewAdminCreate interface.
 */
export function instanceOfEnvelopedReviewAdminCreate(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedReviewAdminCreateFromJSON(json: any): EnvelopedReviewAdminCreate {
  return EnvelopedReviewAdminCreateFromJSONTyped(json, false)
}

export function EnvelopedReviewAdminCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedReviewAdminCreate {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: json['body'],
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedReviewAdminCreateToJSON(value?: EnvelopedReviewAdminCreate | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: value.body,
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
